import { settleMount } from "#ce/framework/mount-ready";

function rootsOf(element) {
  const roots = [];
  let root = element.getRootNode();

  while (root) {
    roots.push(root);
    root = root.host?.getRootNode();
  }

  return roots;
}

/**
 * Resolves like `settleMount(element)`, or with null once `element` leaves the page first. A
 * custom element removed before it mounts never settles.
 *
 * @param {Element} element
 * @returns {Promise<Element | null>}
 */
export function settleConnected(element) {
  if (!element.isConnected) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const observer = new MutationObserver(handleRemoval);

    function finish(value) {
      observer.disconnect();
      resolve(value);
    }

    function handleRemoval() {
      if (!element.isConnected) {
        finish(null);
      }
    }

    for (const root of rootsOf(element)) {
      observer.observe(root, { childList: true, subtree: true });
    }

    settleMount(element).then(finish);
  });
}
